import { backendApi } from "@/services/backend/api";
import {
  CreateRequirementRequest,
  DeleteRequest,
  GetRequirementRequest,
  ListRequirementRequest,
  PutRequirementRequest,
  Requirement,
  RequirementList,
} from "@/services/backend/qpm/requirements/types/requirement";
import {
  Offer,
  UpdatePostalAddressRequest,
  UpdateServiceAddressRequest,
} from "@/services/backend/qpm/offers/types/offer";
import { RequirementDTO } from "@/services/backend/qpm/requirements/types/requirement-dto";

const qpmRequirementServiceApi = backendApi
  .enhanceEndpoints({
    addTagTypes: [
      "QpmSelectedMonitor",
      "QpmSelectedMonitorSummary",
      "QpmRequirement",
      "QpmRequirementArea",
      "QpmRequirementAdditionalInformation",
      "QpmRequirementServiceProperties",
      "QpmRequirementComplementaryService",
      "QpmRequirementPest",
      "QpmRequirementPestCategory",
      "QpmRequirementAreaRisk",
    ],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      qpmRequirementCreate: build.mutation<
        Requirement,
        CreateRequirementRequest
      >({
        query: (request) => ({
          url: `/qpm/requirement`,
          method: "POST",
          body: request,
        }),
        invalidatesTags: ["QpmRequirement"],
      }),
      qpmRequirementPut: build.mutation<Requirement, PutRequirementRequest>({
        query: (request) => ({
          url: `/qpm/requirement`,
          method: "PUT",
          body: request,
        }),
        invalidatesTags: ["QpmRequirement"],
      }),
      qpmRequirementGet: build.query<RequirementDTO, GetRequirementRequest>({
        query: (request) => ({
          url: `/qpm/requirement`,
          method: "GET",
          params: request,
        }),
        providesTags: (result) =>
          result ? [{ type: "QpmRequirement", id: result.id }] : [],
      }),
      qpmRequirementUpdatePostalAddress: build.mutation<
        Requirement,
        UpdatePostalAddressRequest
      >({
        query: (request) => ({
          url: `/qpm/requirement/postal-address`,
          method: "PATCH",
          body: request,
        }),
        invalidatesTags: (_result, _e, request) => [
          { type: "QpmRequirement", id: request.id },
          "QpmRequirement",
        ],
      }),
      qpmRequirementUpdateServiceAddress: build.mutation<
        Offer,
        UpdateServiceAddressRequest
      >({
        query: (request) => ({
          url: `/qpm/requirement/service-address`,
          method: "PATCH",
          body: request,
        }),
        invalidatesTags: (_result, _e, request) => [
          { type: "QpmRequirement", id: request.id },
          "QpmRequirement",
        ],
      }),
      qpmRequirementList: build.query<
        RequirementList,
        Partial<ListRequirementRequest>
      >({
        query: (request) => ({
          url: `/qpm/requirement/list`,
          method: "GET",
          params: {
            request: btoa(JSON.stringify(request)),
          },
        }),
        providesTags: (result) =>
          result ? [{ type: "QpmRequirement", id: "LIST" }] : [],
      }),
      qpmRequirementDelete: build.mutation<null, DeleteRequest>({
        query: (request) => ({
          url: `/qpm/requirement`,
          method: "DELETE",
          body: request,
        }),
        invalidatesTags: () => [{ type: "QpmRequirement", id: "LIST" }],
      }),
    }),
  });

export const {
  useQpmRequirementCreateMutation,
  useQpmRequirementPutMutation,
  useQpmRequirementUpdatePostalAddressMutation,
  useQpmRequirementUpdateServiceAddressMutation,
  useQpmRequirementGetQuery,
  useQpmRequirementListQuery,
  useQpmRequirementDeleteMutation,
} = qpmRequirementServiceApi;
